import React from 'react'
import CreditCardIcon from '@tecuity/sos-icons/react/credit-card-solid'
import BankIcon from '@tecuity/sos-icons/react/bank-solid'
import StarIcon from '@tecuity/sos-icons/react/star'
import StarIconSolid from '@tecuity/sos-icons/react/star-solid'
import TrashIcon from '@tecuity/sos-icons/react/trash'

export default ({ type, brand, last4Digits, isDefault, onRequestDefault, onRequestDelete, savingsAccount }) => {
  const brandDescr = type === "ach" ? (savingsAccount === "true" ? "savings" : "checking") : (brand ? brand : type);
  return (
    <div className="payment-method">
      {type === 'card' && <CreditCardIcon alt='Credit Card icon' />}
      {type === 'ach' && <BankIcon alt='Bank icon' />}
      <span className="text">
        <span className="brand">{brandDescr}</span>
        <em>ending in</em>
        <span className="digits">{last4Digits}</span>
      </span>
      <div className="buttons">
        <button
          className={`control star ${isDefault ? 'default' : ''}`}
          onClick={onRequestDefault}
          disabled={isDefault}
        >
          <div className="center">{isDefault ? <StarIconSolid alt='Star icon' /> : <StarIcon alt='Star icon' />}</div>
        </button>
        <button className="control danger" onClick={onRequestDelete}>
          <div className="center">
            <TrashIcon alt='Trash icon' />
          </div>
        </button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/SavedPayments/PaymentMethod.js